import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * MobileWeekSelector - Week navigation component for mobile
 *
 * Props:
 * - currentWeekStart: Date - Start of the current week (Monday)
 * - onWeekChange: (direction: 'prev' | 'next') => void - Callback when week changes
 */
const MobileWeekSelector = ({ currentWeekStart, onWeekChange }) => {
  // Format week range display
  const formatWeekRange = (weekStart) => {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6); // Sunday

    const formatDate = (date) => {
      const month = date.toLocaleDateString('en-US', { month: 'short' });
      const day = date.getDate();
      return `${month} ${day}`;
    };

    const year = weekStart.getFullYear();
    return `${formatDate(weekStart)} - ${formatDate(weekEnd)}, ${year}`;
  };

  return (
    <div className="w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
      <div className="flex items-center justify-between">
        {/* Previous week button */}
        <button
          onClick={() => onWeekChange('prev')}
          className="
            flex items-center justify-center
            w-12 h-12 rounded-full
            bg-gray-100 dark:bg-gray-700
            hover:bg-gray-200 dark:hover:bg-gray-600
            active:scale-95
            transition-all duration-150
            touch-manipulation
          "
          aria-label="Previous week"
        >
          <ChevronLeft className="w-6 h-6 text-gray-700 dark:text-gray-300" />
        </button>

        {/* Week range display */}
        <div className="flex-1 text-center px-4">
          <div className="text-base font-semibold text-gray-900 dark:text-white">
            {formatWeekRange(currentWeekStart)}
          </div>
        </div>

        {/* Next week button */}
        <button
          onClick={() => onWeekChange('next')}
          className="
            flex items-center justify-center
            w-12 h-12 rounded-full
            bg-gray-100 dark:bg-gray-700
            hover:bg-gray-200 dark:hover:bg-gray-600
            active:scale-95
            transition-all duration-150
            touch-manipulation
          "
          aria-label="Next week"
        >
          <ChevronRight className="w-6 h-6 text-gray-700 dark:text-gray-300" />
        </button>
      </div>
    </div>
  );
};

export default MobileWeekSelector;
